// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"5938e60d","897":"5938e60d"}[chunkId] + ".chunk.css";
};